import { atom } from "jotai";
import { type OrganizationEntity } from "@/api/__generated__/orval/accounts";

export const organizationsAtom = atom<OrganizationEntity[]>([]);
